import { DetailsRow, IDetailsRowProps } from "@bps/fluent-ui";
import { QueryStateIndicator } from "@components/QueryStateIndicator";
import { DeploymentRingFieldDeviceDetail } from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { useFieldDeviceDeploymentRingDetail } from "@libs/api/gateways/field/field-ops-gateway.hooks";

export interface FieldDeviceDeploymentRingTableRowProps
  extends IDetailsRowProps {}

export const FieldDeviceDeploymentRingTableRow = (
  props: FieldDeviceDeploymentRingTableRowProps
) => {
  const { item, ...rest } = props;

  // Patch in the details of this deployment ring
  const fieldDeviceDeploymentRingDetailsQuery = useFieldDeviceDeploymentRingDetail(
    item.id
  );

  const noData = <>No deployment ring details available.</>;

  return (
    <QueryStateIndicator<DeploymentRingFieldDeviceDetail>
      NoDataNode={noData}
      {...fieldDeviceDeploymentRingDetailsQuery}
    >
      {deploymentRingFieldDeviceDetails => {
        const { sortOrder } = item;

        const row = {
          ...rest,
          item: {
            ...deploymentRingFieldDeviceDetails,
            sortOrder
          }
        } as IDetailsRowProps;

        return <DetailsRow {...row} />;
      }}
    </QueryStateIndicator>
  );
};
